import { Component, OnInit } from '@angular/core';
import { egretAnimations } from '../../animations/egret-animations';
import { Config } from '../../services/order/config.service';

@Component({
  selector: 'app-process-template',
  templateUrl: './process-template.component.html',
  styleUrls: ['./process-template.component.scss'],
  animations: egretAnimations,
})
export class ProcessTemplateComponent implements OnInit {
  panelOpenState: any = true;
  currentUser: any = [];
  sessionList: any = [];
  constructor(private sv: Config) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
  }

  ngOnInit(): void {
  }

  checkDone() {
    if (this.sessionList.length == 0) {
      return true;
    }
    if (this.sessionList.find((item) => item.persent != 100)) {
      return false;
    }
    return true;
  }

  changePosition() {}
  click(event: Event) {
    event.stopPropagation();
  }
}
